import React, { useEffect, useState } from 'react';

import Appearance from 'styles/Appearance.js';
import ListField from 'views/ListField.js';
import LottieView from 'views/Lottie.js';
import Request from 'files/Request.js';
import TextField from 'views/TextField.js';
import Utils from 'files/Utils.js';

const LeadSubTypePickerField = ({ canAddNewTarget = true, containerStyle, defaultValue, onChange, onLoad, utils, value }) => {

    const [loading, setLoading] = useState(false);
    const [items, setItems] = useState([]);

    const onNewLeadType = () => {

        let title = null;
        utils.alert.show({
            title: 'New Lead Sub-Type',
            message: 'What would you like to call this lead sub-type?',
            content: (
                <div style={{
                    paddingBottom: 16,
                    paddingLeft: 16,
                    paddingRight: 16,
                    width: '100%'
                }}>
                    <TextField
                    fieldStyle={{
                        textAlign: 'center'
                    }}
                    placeholder={'Name'}
                    onChange={text => title = text} />
                </div>
            ),
            buttons: [{
                key: 'save',
                title: 'Save',
                style: 'default'
            },{
                key: 'cancel',
                title: 'Cancel',
                style: 'cancel'
            }],
            onClick: key => {
                if(key === 'save' && title) {
                    onNewLeadTypeConfirm(title);
                    return;
                }
            }
        })
    }

    const onNewLeadTypeConfirm = async title => {
        try {

            setLoading(true);
            await Utils.sleep(0.25);

            await Request.post(utils, '/clients/', {
                type: 'new_lead_sub_type',
                text: title
            });

            setLoading(false);
            fetchLeadSubTypes();
            utils.content.fetch('lead_sub_type');
            utils.banner.show({
                title: 'Sub-Type Created',
                message: `The "${title}" lead sub-type has been created and added to your list of lead sub-types`
            });

        } catch(e) {
            setLoading(false);
            utils.alert.show({
                title: 'Oops!',
                message: `There was an issue creating your lead sub-type. ${e.message || 'An unknown error occurred'}`
            })
        }
    }

    const getAccessoryButton = () => {
        if(loading === true) {
            return (
                <div style={{
                    alignItems: 'center',
                    borderRadius: 8,
                    backgroundColor: Appearance.colors.primary(),
                    display: 'flex',
                    flex: 'none',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    height: 30,
                    marginLeft: 8,
                    overflow: 'hidden',
                    width: 50
                }}>
                    <LottieView
                    loop={true}
                    autoPlay={true}
                    source={require('files/lottie/dots-white.json')}
                    style={{
                        height: 15,
                        marginBottom: 2,
                        width: 20
                    }}/>
                </div>
            )
        }
        return canAddNewTarget && (
            <div style={{
                flex: 'none',
                height: 30,
                marginLeft: 8,
                width: 30
            }}>
                <img
                className={'text-button'}
                src={window.theme === 'dark' ? 'images/new-badge-green-dark.png' : 'images/new-badge-green-light.png'}
                onClick={onNewLeadType}
                style={{
                    height: '100%',
                    objectFit: 'contain',
                    width: '100%'
                }} />
            </div>
        )
    }

    const getItems = () => {
        if(items.length === 0) {
            return [{
                key: null,
                title: 'No Sub-Types Found',
                disabled: true
            }]
        }
        return items;
    }

    const fetchLeadSubTypes = async () => {
        try {
            let { lead_sub_types } = await Request.get(utils, '/clients/', {
                type: 'lead_sub_types'
            });
            setItems(lead_sub_types);

        } catch(e) {
            utils.alert.show({
                title: 'Oops!',
                message: `There was an issue retrieving the lead sub types list. ${e.message || 'An unknown error occurred'}`
            })
        }
    }

    useEffect(() => {
        if(items.length > 0 && typeof(onLoad) === 'function') {
            onLoad(items);
        }
    }, [items]);

    useEffect(() => {
        fetchLeadSubTypes();
    }, []);

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            width: '100%',
            ...containerStyle
        }}>
            <ListField
            defaultValue={defaultValue}
            items={getItems()}
            onChange={onChange} 
            utils={utils}
            value={value}/>
            {getAccessoryButton()}
        </div>
    )
}
export default LeadSubTypePickerField;
